<form [formGroup]="timeRangeSettingsForm">
  <div class="form-group">
    <label translate>Time Period</label>
    <scitis-required-field-indicator></scitis-required-field-indicator>
    <em [ngbTooltip]="'The allowed time range depends on whether it is streaming to Datastore or InfluxDB. ' +
                      'The limits are 120 minutes and 90 days respectively'|translate"
      class="fa-solid fa-circle-question text-muted ml-1"
    placement="top"></em>
    <div>
      <li class="list-group-item time-range-border">
        <div class="edit-menu-form">

          <div class="form-row">
            <div class="col-md-6">
              <div class="form-group">
                <label><span translate>Value</span></label>
                <scitis-required-field-indicator></scitis-required-field-indicator>
                <input [ngClass]="{'is-invalid': formControls.timeInputValue.errors}" class="form-control"
                  formControlName="timeInputValue" type="number" min="1" pattern="\d*">
                  @if (formControls.timeInputValue.errors) {
                    <div class="invalid-feedback">
                      <span translate>Requires positive integers</span>
                    </div>
                  }
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label><span translate>Time Unit</span></label>
                  <scitis-required-field-indicator></scitis-required-field-indicator>
                  @if (isLoadingStreamingToInfluxEnabled) {
                    <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                  }
                  <ng-select
                    [items]="timeUnits"
                    formControlName="timeUnit"
                    [ngClass]="{'is-invalid': formControls.timeUnit.errors}">
                  </ng-select>
                  @if (formControls.timeUnit.errors) {
                    <div class="invalid-feedback">
                      <span translate>Time Unit is not set!</span>
                    </div>
                  }
                </div>
              </div>
              @if (timeRangeSettingsForm.errors) {
                <div>
                  <span   class="text-danger small pl-1" translate [innerText]="timeRangeSettingsForm.errors.timeToLong"></span>
                </div>
              }
            </div>
          </div>
        </li>

      </div>

    </div>

  </form>
